import Cookies from "js-cookie";
import { BREATHE_ID_TOKEN } from "../constants";

export const isIdTokenPresent = () => {
  return !!Cookies.get(BREATHE_ID_TOKEN);
};
